import floor from 'lodash/floor'

export const calculateAmountInCents = (amount: number): number =>
  floor(amount, 2) * 100

export const DEFAULT_CURRENCY: string = 'CAD'

export const DEFAULT_3DSIFRAME_TIMEOUT = 500
